import React from 'react';
import { useHistory } from 'react-router-dom';
import './RepresentationConfirmation.css';

/**
 * Confirmation page component for OATH hearing representation submission.
 *
 * Displays success message after submitting a representation request.
 * Provides navigation options to return to dashboard or submit another request.
 *
 * @param {Object} props Component props
 * @param {number} props.itemCount Number of hearings submitted for representation
 */
const RepresentationConfirmation = ({ itemCount }) => {
	const history = useHistory();

	/**
	 * Handle submit another request.
	 */
	const handleSubmitAnother = () => {
		window.location.reload();
	};

	return (
		<div className="representation-confirmation-page">
			<div className="confirmation-card">
				<div className="confirmation-icon">
					<svg
						width="80"
						height="80"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<circle cx="12" cy="12" r="10" />
						<path d="M9 12l2 2 4-4" />
					</svg>
				</div>

				<h1>Representation Request Submitted</h1>

				<p className="confirmation-subtext">
					Our team will review your request and contact you shortly at the
					email address associated with your account.
				</p>

				<div className="confirmation-actions">
					<button
						className="btn btn-primary"
						onClick={() => history.push('/dashboard')}
					>
						Go to Dashboard
					</button>
					<button className="btn btn-secondary" onClick={handleSubmitAnother}>
						Submit Another Request
					</button>
				</div>
			</div>
		</div>
	);
};

export default RepresentationConfirmation;
